(() => {
  const initCollapsibleTabs = (root) => {
    if (!root || root.getAttribute('data-collapsible-tabs-ready') === 'true') return;
    root.setAttribute('data-collapsible-tabs-ready', 'true');

    const toggles = root.querySelectorAll('.collapsible-tabs__trigger');

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const currentItem = toggle.closest('.collapsible-tabs__item');
        const currentContent = toggle.nextElementSibling;
        if (!currentContent) return;

        const isOpen = toggle.getAttribute('aria-expanded') === 'true';

        toggles.forEach((btn) => {
          const item = btn.closest('.collapsible-tabs__item');
          const content = btn.nextElementSibling;
          if (!content || item === currentItem) return;

          btn.setAttribute('aria-expanded', 'false');
          content.style.height = `${content.scrollHeight}px`;
          requestAnimationFrame(() => {
            content.style.height = '0px';
          });
        });

        if (isOpen) {
          currentContent.style.height = `${currentContent.scrollHeight}px`;
          requestAnimationFrame(() => {
            currentContent.style.height = '0px';
          });
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          currentContent.style.height = 'auto';
          const height = currentContent.scrollHeight;
          currentContent.style.height = '0px';
          requestAnimationFrame(() => {
            currentContent.style.height = `${height}px`;
          });
          toggle.setAttribute('aria-expanded', 'true');
        }

        const onEnd = () => {
          if (toggle.getAttribute('aria-expanded') === 'true') {
            currentContent.style.height = 'auto';
          }
          currentContent.removeEventListener('transitionend', onEnd);
        };
        currentContent.addEventListener('transitionend', onEnd);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.collapsible-tabs').forEach((root) => initCollapsibleTabs(root));
  });

  document.addEventListener('shopify:section:load', (event) => {
    const roots = event.target.querySelectorAll('.collapsible-tabs');
    roots.forEach((root) => initCollapsibleTabs(root));
  });
})();
